import { render, staticRenderFns } from "./gsp-add-edit-dialog.html?vue&type=template&id=75fff410&scoped=true&"
import script from "./gsp-add-edit-dialog?vue&type=script&lang=ts&"
export * from "./gsp-add-edit-dialog?vue&type=script&lang=ts&"
import style0 from "./gsp-add-edit-dialog.scss?vue&type=style&index=0&id=75fff410&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fff410",
  null
  
)

/* custom blocks */
import block0 from "./gsp-add-edit-dialog.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fviews%2Froles-services%2Fgsp-dialog%2Fgsp-add-edit-dialog%2Fgsp-add-edit-dialog.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VCol,VDialog,VForm,VIcon,VRow,VSpacer,VToolbar,VToolbarTitle})
